export const daysArr = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
